import { all, takeEvery, call, put } from "redux-saga/effects";
import { info, requestKey, assignKey } from "services/apis/license";
import actions from "./actions";
import { toastr } from "react-redux-toastr";

function* loading(isLoading = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
    },
  });
}

export function* INFO() {
  yield loading(true);

  const response = yield call(info);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* REQUEST() {
  yield loading(true);

  const response = yield call(requestKey);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        requestKey: response,
        loading: false,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* ASSIGN({ payload }) {
  const { body } = payload;
  yield loading(true);

  const response = yield call(assignKey, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
        error: false,
      },
    });
    yield put({ type: "license/INFO" });
    toastr.success("Assign succeeded", "New licence is activated!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.INFO, INFO),
    takeEvery(actions.REQUEST, REQUEST),
    takeEvery(actions.ASSIGN, ASSIGN),
  ]);
}
